import Constants from '../utils/consts';
import SqlString from 'sqlstring';
var http = require('follow-redirects').https;
var qs = require('querystring');


export default async function saveFile(username, token, fileName, data) {
    return new Promise(async function (resolve, reject) {
        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': Constants.apisFolder + 'saveFile.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            
            const resp = JSON.parse(body.toString().replace(/\\/g, ''));
            resolve(resp);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        // alert(JSON.stringify(content))

        //var blobData = await data.blob.text();

 //       let reader = new FileReader();
  //      reader.readAsDataURL(data.blob); // converts the blob to base64 and calls onload

//        reader.onload = function() {
            var postData = qs.stringify({
                'uname': username,
                'token': token,
                'fileName': fileName,
//                'data': reader.result
                'data': data
            });
       //     console.log(postData);
            req.write(postData);
    
            req.end();
  //      };



        
    });
}
